export const styles = {
  dragHandle: {
    minWidth: '20px',
    touchAction: 'none',
    borderRadius: '5px',
    cursor: 'grab',
    border: 'none',
    outline: 'none',
    appearance: 'none',
    backgroundColor: 'transparent',
    WebkitTapHighlightColor: 'transparent',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    '&:focus-visible': {
      boxShadow: '0 0 0 2px #4c9ffe',
    },
  },
};
